/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancelevent1Inputs */

const en_cancelevent1 = /** @type {(inputs: Cancelevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel Event`)
};

const de_cancelevent1 = /** @type {(inputs: Cancelevent1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absagen`)
};

/**
* | output |
* | --- |
* | "Cancel Event" |
*
* @param {Cancelevent1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cancelevent1 = /** @type {((inputs?: Cancelevent1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancelevent1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancelevent1(inputs)
	return de_cancelevent1(inputs)
});
export { cancelevent1 as "cancelEvent" }